
import React from 'react'
import icon from './svgs/refresh.svg'
import { BaseIcon } from './_base'

export const RefreshIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
